import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GummyBurger from "../components/GummyBurger";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Header />
      <main className="container-site flex flex-col items-center py-16 text-center sm:py-24">
        <GummyBurger
          exploded
          className="w-full max-w-xs animate-float"
          title="Ilustrasi lapisan gummy Yupi Burger yang terlepas"
        />
        <h1 className="mt-10 font-display text-4xl font-extrabold tracking-tight text-plum sm:text-5xl">
          404 — Waduh, Lapisannya Ketumpah!
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-plum-soft">
          Halaman yang kamu cari tidak ditemukan. Yuk susun lagi dan kembali ke beranda, atau
          langsung lihat varian gummy burger kami.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="notfound-cta-home" className="btn-primary">
            <Home className="h-5 w-5" aria-hidden="true" />
            Kembali ke Beranda
          </Link>
          <Link to="/produk/" data-testid="notfound-cta-products" className="btn-secondary">
            Lihat Produk
            <ArrowRight className="h-5 w-5" aria-hidden="true" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
